module.exports = __webpack_public_path__ + "static/media/edna45.9b790e3c.png";